import { ColumnsEdit } from "types/models/column-table-edit";

export const columns: ColumnsEdit = [
  { title: "STT", key: "stt", dataIndex: "stt", width: 10, align: "center" },
  {
    title: "Chỉ định đã chọn",
    key: "chiDinhDaChon",
    dataIndex: "chiDinhDaChon",
    width: 200,
    align: "left",
  },
];
